import React from "react";
import "./Card.css";
import { Link } from "react-router-dom";
import renderHTML from "react-render-html";
function Card(props) {
  //console.log("Cards::" + props);
  const {
    title,
    subtitle,
    assetId,
    autor,
    coverUrl,
    eventDetail,
    textButtonPoster,
    textButtonPosterActive,
    thirdPartyId
  } = props.info;
  const lang = props.lang;
  //eti idiomas
  let more = "";
  if (lang === "cat") {
    more = "Més informació";
  }
  if (lang === "esp") {
    more = "Más información";
  }
  if (lang === "eng") {
    more = "View more information";
  }
  return (
    <>
      <div className="card">
        {textButtonPosterActive ? (
          <div className="overlay__Button">{textButtonPoster}</div>
        ) : (
          <></>
        )}
        <img className="card__img" src={coverUrl} alt="" />
        <div className="card__info">
          <p className="card__info__title">{title && renderHTML(title)}</p>
          <p className="card__info__subtitle">{subtitle && renderHTML(subtitle)}</p>
          <p className="card__info__author">{autor}</p>
        </div>
        <Link to={`/ppv/${thirdPartyId}`} className="overlay__card">
          <p>{eventDetail && renderHTML(eventDetail) }</p>
          <div className="overlay__card_button">{more}</div>
        </Link>
        {/* <div className="overlay_card_button">Más informació</div>  */}
      </div>
    </>
  );
}

export default Card;
